export type VideoProvider = 'youtube' | 'facebook' | 'instagram' | 'tiktok' | 'vimeo';
export type MediaPlacement =
  | 'hero'
  | 'before_catalog'
  | 'after_catalog'
  | 'footer'
  | 'gallery'
  | 'demonstration';
export interface ExternalVideo {
  id: string;
  provider: VideoProvider;
  external_id: string;
  url: string;
  title: string;
  cover_image_id?: string | null;
  cover_url?: string | null;
  aspect_ratio?: 'landscape' | 'portrait' | 'square';
  used_on_pages?: Array<{ id: string; name: string }>;
}
export type CommercialMedia =
  | (ExternalVideo & { kind: 'video'; placement: MediaPlacement })
  | { id: string; kind: 'image'; url: string; title: string; placement: MediaPlacement };
export interface MediaSelection {
  kind: 'image' | 'video';
  id: string;
  placement: MediaPlacement;
}
export interface MediaImage {
  id: string;
  url: string;
  alt_text?: string | null;
}
export const PROVIDER_LABELS: Record<VideoProvider, string> = {
  youtube: 'YouTube',
  facebook: 'Facebook',
  instagram: 'Instagram',
  tiktok: 'TikTok',
  vimeo: 'Vimeo',
};
